var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import ContentLoader from "react-content-loader";
import * as React from "react";
import { Typography } from "@material-ui/core";
import styled from "styled-components";
import { useTypedSelector } from "../../state/store";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import ThemeProviderContext from "../../contexes/themeProviderContext";
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.5rem 2rem;\n  color: white;\n  background: #1473e6;\n  font-family: Poppins !important;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.5rem 2rem;\n  color: white;\n  background: #1473e6;\n  font-family: Poppins !important;\n"])));
var IconContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-right: 1rem;\n  font-size: 3.5rem;\n  line-height: 1.2;\n  color: #15447d;\n"], ["\n  margin-right: 1rem;\n  font-size: 3.5rem;\n  line-height: 1.2;\n  color: #15447d;\n"])));
var TitleContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-right: auto;\n  text-align: start;\n"], ["\n  margin-right: auto;\n  text-align: start;\n"])));
var PointsContainer = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var QuizStatusMessage = styled(Typography)(templateObject_5 || (templateObject_5 = __makeTemplateObject([""], [""])));
var PointsText = styled(Typography)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-size: 1.5rem !important;\n  text-align: end;\n  display: inline;\n  max-height: 100%;\n\n  @media (max-width: 550px) {\n    text-align: start;\n  }\n"], ["\n  font-size: 1.5rem !important;\n  text-align: end;\n  display: inline;\n  max-height: 100%;\n\n  @media (max-width: 550px) {\n    text-align: start;\n  }\n"])));
var PointsLabelText = styled(Typography)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  font-size: 1rem !important;\n\n  @media (max-width: 550px) {\n    text-align: start;\n    margin-top: 10px;\n  }\n"], ["\n  font-size: 1rem !important;\n\n  @media (max-width: 550px) {\n    text-align: start;\n    margin-top: 10px;\n  }\n"])));
var SpaceFillerDiv = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  max-height: 31.2px;\n"], ["\n  max-height: 31.2px;\n"])));
var TopInfoBar = function TopInfoBar(_a) {
  var staticBars = _a.staticBars,
    alternativeQuizLabel = _a.alternativeQuizLabel;
  var themeProvider = React.useContext(ThemeProviderContext);
  var quizAnswer = useTypedSelector(function (state) {
    return state.quizAnswer.quizAnswer;
  });
  var userQuizState = useTypedSelector(function (state) {
    return state.user.userQuizState;
  });
  var loggedIn = !!useTypedSelector(function (state) {
    return state.user.accessToken;
  });
  var quiz = useTypedSelector(function (state) {
    return state.quiz;
  });
  var languageInfo = useTypedSelector(function (state) {
    return state.language.languageLabels;
  });
  var displayBars = useTypedSelector(function (state) {
    return state.loadingBars;
  });
  var title;
  var quizLabel;
  var answeredLabel;
  var unansweredLabel;
  var rejectedLabel;
  var pointsLabel;
  var receivedPoints;
  var formattedReceivedPoints;
  var availablePoints;
  var colon;
  if (languageInfo) {
    quizLabel = alternativeQuizLabel === undefined ? languageInfo.general.quizLabel : alternativeQuizLabel;
    pointsLabel = languageInfo.general.pointsLabel;
    answeredLabel = languageInfo.general.answered;
    unansweredLabel = languageInfo.general.unanswered;
    rejectedLabel = languageInfo.general.rejected;
    colon = quizLabel.length > 0 ? ":" : "";
  }
  var answerStatus = quizAnswer.status;
  var status = answerStatus ? answerStatus !== "rejected" && answerStatus !== "spam" ? "answered" : "rejected" : "";
  var statusLabel = status ? status === "rejected" ? rejectedLabel : answeredLabel : unansweredLabel;
  var titleReplacement;
  var pointsPortion;
  if (!quiz) {
    title = "";
    formattedReceivedPoints = "";
    availablePoints = "";
    titleReplacement = displayBars || staticBars ? React.createElement(QuizTitleLoadingBar, {
      animate: !staticBars
    }) : React.createElement(SpaceFillerDiv, null);
    pointsPortion = displayBars || staticBars ? React.createElement(QuizPointsLoadingBar, {
      animate: !staticBars
    }) : React.createElement(SpaceFillerDiv, null);
  } else {
    title = quiz.title;
    availablePoints = quiz.points;
    if (loggedIn) {
      receivedPoints = userQuizState && userQuizState.pointsAwarded ? userQuizState.pointsAwarded : 0;
      formattedReceivedPoints = Number.isInteger(receivedPoints) ? receivedPoints : receivedPoints.toFixed(2);
      pointsPortion = React.createElement(PointsText, {
        component: "div",
        paragraph: false
      }, formattedReceivedPoints + "/" + availablePoints);
    } else {
      pointsPortion = React.createElement("div", {
        style: {
          height: "31.2px"
        }
      }, React.createElement(StyledShortPointContentLoader, {
        animate: false,
        height: 25,
        width: 30,
        backgroundColor: "#ffffff",
        backgroundOpacity: 0.6,
        foregroundColor: "#dddddd",
        foregroundOpacity: 0.6
      }, React.createElement("rect", {
        x: "0",
        y: "0",
        rx: "10",
        ry: "10",
        width: "30",
        height: "25"
      })), React.createElement(PointsText, {
        component: "div",
        paragraph: false
      }, "/" + availablePoints));
    }
  }
  var ProvidedIcon = themeProvider.topInfoBarIcon;
  var TopInfoBarContainer = themeProvider.topInfoBarContainer || Container;
  return React.createElement(TopInfoBarContainer, {
    loggedIn: loggedIn
  }, React.createElement(IconContainer, null, ProvidedIcon ? React.createElement(React.Fragment, null, React.createElement(ProvidedIcon, {
    status: status
  }), React.createElement(QuizStatusMessage, {
    className: status,
    variant: "subtitle1"
  }, statusLabel)) : React.createElement(FontAwesomeIcon, {
    icon: faQuestionCircle
  })), React.createElement(TitleContainer, null, React.createElement(Typography, {
    component: "div",
    variant: "subtitle1",
    id: "quiz-type-label",
    style: {
      lineHeight: "1.2",
      opacity: "0.8"
    }
  }, quizLabel, colon), quiz ? React.createElement(Typography, {
    variant: "h5",
    component: "h2",
    "aria-describedby": "quiz-type-label"
  }, title) : titleReplacement), (!quiz || !quiz.excludedFromScore) && React.createElement(PointsContainer, null, React.createElement(PointsLabelText, {
    component: "div",
    paragraph: false
  }, pointsLabel, ":"), pointsPortion));
};
var QuizTitleLoadingBar = function QuizTitleLoadingBar(_a) {
  var animate = _a.animate;
  return React.createElement(StyledQuizTitleContentLoader, {
    animate: animate,
    height: 40,
    width: 100,
    speed: 2,
    backgroundColor: "#ffffff",
    backgroundOpacity: 0.6,
    foregroundColor: "#dddddd",
    foregroundOpacity: 0.6
  }, React.createElement("rect", {
    x: "0",
    y: "10",
    rx: "4",
    ry: "20",
    width: "100",
    height: "30"
  }));
};
var StyledQuizTitleContentLoader = styled(ContentLoader)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  width: 100%;\n  max-width: 300px;\n"], ["\n  width: 100%;\n  max-width: 300px;\n"])));
var QuizPointsLoadingBar = function QuizPointsLoadingBar(_a) {
  var animate = _a.animate;
  return React.createElement(StyledQuizPointsContentLoader, {
    animate: animate,
    height: 40,
    width: 100,
    speed: 2,
    backgroundColor: "#ffffff",
    backgroundOpacity: 0.6,
    foregroundColor: "#dddddd",
    foregroundOpacity: 0.6
  }, React.createElement("rect", {
    x: "0",
    y: "10",
    rx: "25",
    ry: "25",
    width: "100",
    height: "30"
  }));
};
var StyledQuizPointsContentLoader = styled(ContentLoader)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  width: 100%;\n  max-width: 45px;\n  height: 31.2px;\n"], ["\n  width: 100%;\n  max-width: 45px;\n  height: 31.2px;\n"])));
var StyledShortPointContentLoader = styled(ContentLoader)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  max-width: 35px;\n  max-height: 31.2px;\n  vertical-align: top;\n  position: relative;\n  top: 5px;\n"], ["\n  max-width: 35px;\n  max-height: 31.2px;\n  vertical-align: top;\n  position: relative;\n  top: 5px;\n"])));
export default TopInfoBar;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;